import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, FileJson } from "lucide-react";
import { PageHeader, Loading, ErrorState, Empty, Status } from "../components/Layout";
import { useApi, useResource } from "../lib/api";

export function DownloadButton({ f, api }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await api("GET", `/assets/${f.asset_id}/audio`, undefined, { raw: true });
      const url = URL.createObjectURL(await r.blob());
      const a = document.createElement("a"); a.href = url; a.download = `songape-${f.label}.${f.ext}`; a.click();
      setTimeout(() => URL.revokeObjectURL(url), 5000);
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return <button className="btn btn-ghost btn-sm" onClick={go} disabled={busy} data-testid={`download-${f.label}`}><Download size={12} />{f.label.replace(/_/g, " ")} ({Math.round(f.size / 1024)} KB)</button>;
}

export default function Exports() {
  const api = useApi();
  const ex = useResource("/exports");
  const [man, setMan] = useState(null);
  const showManifest = async (x) => { try { setMan(await api("GET", `/exports/${x.id}/manifest`)); } catch (e) { toast.error(e.message); } };
  return (
    <div>
      <PageHeader title="Exports" sub="Server-rendered, integrity-checked files. Downloads are rechecked against your export rights each time." />
      {ex.loading ? <Loading /> : ex.error ? <ErrorState error={ex.error} onRetry={ex.reload} /> : ex.data.length === 0 ? <Empty title="No exports yet" action={<Link to="/studio" className="btn btn-primary btn-sm">Open Studio</Link>}>Save a version in a project and render an export.</Empty> :
        <div className="grid lg:grid-cols-2 gap-4">{ex.data.map((x) => (
          <div key={x.id} className="card p-5 space-y-3" data-testid={`export-card-${x.id}`}>
            <div className="flex justify-between gap-2"><Link to={`/studio/${x.project_id}`} className="font-semibold hover:text-[var(--pink)]">{x.project_title}</Link><Status value={x.integrity_passed ? "integrity passed" : "failed"} /></div>
            <div className="text-xs muted">{x.format.toUpperCase()} · peak {x.render?.peak} · vocal operations: {x.render?.vocal_operations?.length ? x.render.vocal_operations.join(", ") : "none (unity gain)"} · {x.render?.master_processing ? "peak-normalised final mix" : "no master processing"} · {new Date(x.created_at).toLocaleString()}</div>
            <div className="flex flex-wrap gap-2">{x.files.map((f) => <DownloadButton key={f.asset_id + f.label} f={f} api={api} />)}
              <button className="btn btn-ghost btn-sm" onClick={() => showManifest(x)} data-testid={`manifest-${x.id}`}><FileJson size={12} />Manifest</button></div>
          </div>))}</div>}
      {man && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4" onClick={() => setMan(null)}>
        <pre className="card p-4 text-[11px] whitespace-pre-wrap break-all max-h-[80vh] overflow-auto max-w-3xl w-full" onClick={(e) => e.stopPropagation()} data-testid="manifest-view">{JSON.stringify(man, null, 2)}</pre></div>}
    </div>
  );
}
